import styled from 'styled-components';

export const SParagraph = styled.p`
    margin-bottom: 1.5rem;
`;
